export const loadAlertifyAsync = ()  => {
    return new Promise((resolve, reject) => {
        Promise.all([
            import('alertifyjs'),
            import('./alertify.scss')
        ]).then(result => {
            return resolve(result[0].default);
        });
    });
}